<template>
  <div
    class="tw:w-full tw:bg-blue-500 tw:px-4 tw:py-2 tw:flex tw:items-center tw:justify-center tw:gap-4 max-import-bar-height"
  >
    <span class="tw:text-white tw:body-1 tw:line-clamp-2">
      {{ trans._notifications.importContacts.text }}
    </span>

    <EdroneButton size="medium" @click="goToImport">{{ trans._notifications.importContacts.button }}</EdroneButton>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { MANUAL_IMPORT_BAR_HEIGHT } from "vue-app/types/enums";
import EdroneButton from "edrone-components/EdroneButton.vue";
import { amplitudeSendEvent } from "vue-app/utils/amplitude";

const router = useRouter();

const goToImport = () => {
  amplitudeSendEvent("TopBar_ImportContacts_Clicked");
  router.push("/app/import/v2/upload");
};

const importBarHeightCss = `${MANUAL_IMPORT_BAR_HEIGHT}rem`;
</script>

<style scoped>
.max-import-bar-height {
  max-height: v-bind(importBarHeightCss);
}
</style>
